import {RootStore} from '../../stores/RootStore';

export const getOrigin = (rootStore: RootStore): string => {
  return rootStore.origin;
};
